import { secondsToMinAndSec } from '@/utils/numberUtils'

export default {

  state: {
    editedPlaylist: null
  },

  mutations: {

    removeSongOnEditedPlaylist (state, index) {
      const newPlaylist = Object.assign({}, state.editedPlaylist)
      newPlaylist.songList.splice(index, 1)
      state.editedPlaylist = newPlaylist
    },

    clearEditedPlaylist (state) {
      state.editedPlaylist = null
    },

    initEditedPlaylist (state) {
      state.editedPlaylist = {
        name: '',
        shuffle: true,
        songList: []
      }
    },

    updateEditedPlaylist (state, update) {
      const newPlaylist = Object.assign({}, state.editedPlaylist)
      if (update.key === 'songList') {
        const newSongs = (Array.isArray(update.value) ? update.value : [update.value]).map(song => {
          song.hoursAndSeconds = secondsToMinAndSec(song.duration)
          return song
        })
        newPlaylist.songList = state.editedPlaylist.songList.concat(newSongs)
      } else if (update.key === 'songListReorder') {
        newPlaylist.songList = update.value
      } else {
        newPlaylist[update.key] = update.value
      }
      state.editedPlaylist = newPlaylist
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/playlistEdit.js